"use strict";var r=require("./isBrowser-60045f2d.js").isBrowser()&&window.__IS_HAPPO_RUN;exports.isTestRender=function(){return r};
//# sourceMappingURL=isTestRender-94dc4b66.js.map
